import React from 'react';
import vboxImg from '../../assets/img/vbox.png';

export default function PraticalWork() {
  const styles = {
    heading: {
      color: 'white'
    },
    li: {
      marginBottom: '20px'
    },
    code: {
      backgroundColor: '#2d3748',
      color: '#e2e8f0',
      padding: '10px',
      borderRadius: '5px',
      fontFamily: 'monospace',
      fontSize: '0.9em',
      margin: '10px 0'
    },
    warning: {
      backgroundColor: '#fed7d7',
      color: '#c53030',
      padding: '15px',
      borderRadius: '5px',
      border: '1px solid #feb2b2',
      margin: '15px 0'
    },
    info: {
      backgroundColor: '#bee3f8',
      color: '#2b6cb0',
      padding: '15px',
      borderRadius: '5px',
      border: '1px solid #90cdf4',
      margin: '15px 0'
    }
  };

  return (
    <>
      <section>
        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>TP pfSense - Lab Virtuel</h1>
        </section>

        <section data-auto-animate>
          <h1>Objectifs du TP</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              Installer et configurer pfSense dans un environnement virtuel
            </li>
            <li className="fragment" style={styles.li}>
              Créer un réseau local virtuel isolé
            </li>
            <li className="fragment" style={styles.li}>
              Configurer les règles de pare-feu et NAT
            </li>
            <li className="fragment" style={styles.li}>
              Mettre en place un serveur DHCP
            </li>
            <li className="fragment" style={styles.li}>
              Tester la connectivité et la sécurité
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Architecture cible</h1>
          <div style={styles.info}>
            <strong>Réseau cible :</strong> 192.168.2.0/24 (réseau interne
            isolé)
          </div>
          <ul>
            <li className="fragment" style={styles.li}>
              <strong>WAN :</strong> Interface connectée au réseau physique
              (accès Internet)
            </li>
            <li className="fragment" style={styles.li}>
              <strong>LAN :</strong> Interface connectée au réseau virtuel isolé
            </li>
            <li className="fragment" style={styles.li}>
              <strong>DMZ :</strong> Interface pour les serveurs publics
              (optionnel)
            </li>
          </ul>
        </section>

        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>Méthode 1 : VirtualBox Classique</h1>
        </section>

        <section data-auto-animate>
          <h1>Prérequis VirtualBox</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              VirtualBox installé sur votre machine
            </li>
            <li className="fragment" style={styles.li}>
              Image ISO pfSense téléchargée
            </li>
            <li className="fragment" style={styles.li}>
              Au moins 1 Go de RAM disponible
            </li>
            <li className="fragment" style={styles.li}>
              16 Go d'espace disque libre
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>
            <span role="img" aria-label="warning">
              ⚠️
            </span>{' '}
            Attention - Problème Bridge
          </h1>
          <div style={styles.warning}>
            <strong>IMPORTANT :</strong> Si vous utilisez le mode "Accès par
            pont" (Bridge) sur le réseau de l'IUT, votre machine risque d'être
            bannie du switch réseau !
          </div>
          <ul>
            <li className="fragment" style={styles.li}>
              Le mode bridge expose directement votre VM au réseau physique
            </li>
            <li className="fragment" style={styles.li}>
              Cela peut causer des conflits d'adresses IP
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Solution recommandée :</strong> Utiliser le mode "Réseau
              interne" pour toutes les interfaces
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Configuration VirtualBox - Étape 1</h1>
          <img className="r-stretch" src={vboxImg} alt="VirtualBox" />
          <ul>
            <li className="fragment" style={styles.li}>
              Créer une VM "FreeBSD (64-bit)"
            </li>
            <li className="fragment" style={styles.li}>
              Allouer 1 Go de RAM minimum
            </li>
            <li className="fragment" style={styles.li}>
              Créer un disque virtuel de 16 Go
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Configuration VirtualBox - Étape 2</h1>
          <h3>Configuration des interfaces réseau</h3>
          <ul>
            <li className="fragment" style={styles.li}>
              <strong>Adapter 1 (WAN) :</strong> "Réseau interne" → "WAN_NET"
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Adapter 2 (LAN) :</strong> "Réseau interne" → "LAN_NET"
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Adapter 3 (DMZ) :</strong> "Réseau interne" → "DMZ_NET"
              (optionnel)
            </li>
          </ul>
          <div style={styles.info}>
            <strong>Note :</strong> Cette configuration évite les problèmes de
            bridge en créant des réseaux virtuels isolés.
          </div>
        </section>

        <section data-auto-animate>
          <h1>Installation pfSense</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              Monter l'ISO pfSense dans la VM
            </li>
            <li className="fragment" style={styles.li}>
              Démarrer la VM et suivre l'assistant d'installation
            </li>
            <li className="fragment" style={styles.li}>
              Choisir "Install pfSense" → "Auto (ZFS)" → "Reboot"
            </li>
            <li className="fragment" style={styles.li}>
              Au redémarrage, accepter les assignations d'interfaces par défaut
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Configuration initiale</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              <strong>WAN :</strong> 192.168.1.1/24 (simulation réseau physique)
            </li>
            <li className="fragment" style={styles.li}>
              <strong>LAN :</strong> 192.168.2.1/24 (réseau interne)
            </li>
            <li className="fragment" style={styles.li}>
              Désactiver "Block private networks" sur WAN
            </li>
            <li className="fragment" style={styles.li}>
              Configurer un mot de passe admin fort
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Alternative : Vagrant</h1>
          <div style={styles.info}>
            <strong>Pour ceux qui le souhaitent :</strong> Une configuration
            Vagrant est disponible pour automatiser le déploiement. Consultez le
            fichier <code>Vagrantfile.pfsense</code> et le{' '}
            <code>README-pfsense-lab.md</code> pour plus de détails.
          </div>
          <ul>
            <li className="fragment" style={styles.li}>
              Configuration automatisée en une commande
            </li>
            <li className="fragment" style={styles.li}>
              Idéal pour ceux qui préfèrent l'automatisation
            </li>
            <li className="fragment" style={styles.li}>
              Même architecture réseau que la méthode manuelle
            </li>
          </ul>
        </section>

        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>Configuration pfSense</h1>
        </section>

        <section data-auto-animate>
          <h1>Accès à l'interface web</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              URL : <code>https://192.168.2.1</code>
            </li>
            <li className="fragment" style={styles.li}>
              Login : <code>admin</code>
            </li>
            <li className="fragment" style={styles.li}>
              Mot de passe : celui configuré lors de l'installation
            </li>
            <li className="fragment" style={styles.li}>
              Accepter le certificat auto-signé
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Configuration DHCP</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              Services → DHCP Server
            </li>
            <li className="fragment" style={styles.li}>
              Activer le serveur DHCP sur l'interface LAN
            </li>
            <li className="fragment" style={styles.li}>
              Plage d'adresses : 192.168.2.100 - 192.168.2.200
            </li>
            <li className="fragment" style={styles.li}>
              DNS : 8.8.8.8, 8.8.4.4
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Règles de pare-feu</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              Firewall → Rules → LAN
            </li>
            <li className="fragment" style={styles.li}>
              Vérifier la règle "Default allow LAN to any rule"
            </li>
            <li className="fragment" style={styles.li}>
              Créer des règles spécifiques selon vos besoins
            </li>
            <li className="fragment" style={styles.li}>
              Tester la connectivité depuis le client
            </li>
          </ul>
        </section>

        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>Tests et Validation</h1>
        </section>

        <section data-auto-animate>
          <h1>Tests de connectivité</h1>
          <div style={styles.code}>
            {`# Depuis le client VM
ping 192.168.2.1        # Ping vers pfSense
ping 8.8.8.8           # Ping vers Internet
nslookup google.com    # Test DNS
curl -I https://google.com  # Test HTTP/HTTPS`}
          </div>
        </section>

        <section data-auto-animate>
          <h1>Tests de sécurité</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              Vérifier que le trafic non autorisé est bloqué
            </li>
            <li className="fragment" style={styles.li}>
              Tester les règles de pare-feu personnalisées
            </li>
            <li className="fragment" style={styles.li}>
              Analyser les logs dans Status → System Logs
            </li>
            <li className="fragment" style={styles.li}>
              Utiliser des outils comme nmap pour scanner le réseau
            </li>
          </ul>
        </section>

        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>Extensions Avancées</h1>
        </section>

        <section data-auto-animate>
          <h1>Fonctionnalités avancées</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              <strong>VPN :</strong> Configuration OpenVPN ou IPsec
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Portail captif :</strong> Authentification des
              utilisateurs
            </li>
            <li className="fragment" style={styles.li}>
              <strong>IDS/IPS :</strong> Installation de Suricata
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Proxy :</strong> Squid pour le filtrage web
            </li>
            <li className="fragment" style={styles.li}>
              <strong>Monitoring :</strong> Graphiques de trafic et statistiques
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Ressources utiles</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              <a href="https://www.it-connect.fr/comment-installer-pfsense-dans-virtualbox-pour-creer-un-lab-virtuel/">
                Tutoriel IT-Connect (référence)
              </a>
            </li>
            <li className="fragment" style={styles.li}>
              <a href="https://docs.netgate.com/pfsense/">
                Documentation officielle pfSense
              </a>
            </li>
            <li className="fragment" style={styles.li}>
              <a href="https://www.vagrantup.com/docs">Documentation Vagrant</a>
            </li>
            <li className="fragment" style={styles.li}>
              <a href="https://shop.netgate.com/a/downloads/-/3e0ee062ee8c95ab/fed7038ee9372287">
                Téléchargement ISO pfSense
              </a>
            </li>
          </ul>
        </section>

        <section data-auto-animate>
          <h1>Conclusion</h1>
          <ul>
            <li className="fragment" style={styles.li}>
              pfSense est un excellent outil pour apprendre la sécurité réseau
            </li>
            <li className="fragment" style={styles.li}>
              Configuration manuelle recommandée pour l'apprentissage
            </li>
            <li className="fragment" style={styles.li}>
              Le lab virtuel permet d'expérimenter sans risque
            </li>
            <li className="fragment" style={styles.li}>
              Base solide pour comprendre les pare-feu professionnels
            </li>
          </ul>
        </section>
      </section>
    </>
  );
}
